/* eslint-disable */
import React from "react";
import axios from "axios";

export const basicUrl = `https://py.qubx3d.com/api/v1`;
export const ipAddressToken = "http://188.166.169.201:8088/api/v1";
const instance = axios.create({
  baseURL: `${basicUrl}`,
});

import { getAuthToken } from "./http-non-token";
export { getAuthToken };

instance.interceptors.request.use((config) => {
  const token = getAuthToken();
  if (token) {
    config.headers = config.headers || {};
    const existing = config.headers.Authorization || config.headers.authorization;
    if (existing) {
      delete config.headers.authorization;
      config.headers.Authorization = existing;
      return config;
    }
    delete config.headers.authorization;
    config.headers.Authorization = `Bearer ${token}`;
  }
  return config;
});

instance.interceptors.response.use(
  (response) => response,
  (error) => {
    if (
      error.response &&
      error.response.status === 401 &&
      !error.config?.url?.includes("/login")
    ) {
      localStorage.removeItem("user");
      if (window.location.pathname !== "/login") {
        window.location.href = "/login";
      }
    }
    return Promise.reject(error);
  }
);

export const httpToken = instance;
export const endpointsToken = {
  request: "/request",
  updateRequest: "/request/update",
  createRequest: "/request/create",
  requestStatus: "/status",
  smsTemplates: "/sms/template",
  qubxOperator: "/employeeProfile",
  note: "/note",
  createNote: "/note/create",
  sirvUpload: "/sirv/upload-file/",
  diconSource: "/diconSource",
  requestPrice: "/request/price/",
  user: "/user/",
  changePassword: "/user/changePassword/",
  createDoctor: "/user/doctor-rc/create",
  notifications: "/notifications",
  updateNotification: "/notifications/update",
  updateGroupNotifications: "/notifications/read",
  service: "/service",
};
